import { render, staticRenderFns } from "./PolicyRate.vue?vue&type=template&id=4121af5a"
import script from "./PolicyRate.vue?vue&type=script&lang=js"
export * from "./PolicyRate.vue?vue&type=script&lang=js"
import style0 from "./PolicyRate.vue?vue&type=style&index=0&id=4121af5a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports